import remove from '@mailobj-browser/front/js/tree/remove.js'
import { handle } from '../form.js'

const handler = ({ form }) => {
  remove(form)
}

export default button => {
  handle(button, handler)
}
